import { Form } from "formik";
import styled from "styled-components";
import { Tabs } from "../Tabs";
import { TabsTitlesContainer, TabTitle } from "../Tabs/style";

export const CustomFormikForm = styled(Form)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 8px;
  max-width: 400px;
`;

export const CustomTabs = styled(Tabs)`
  padding-bottom: 0px;

  ${TabsTitlesContainer} {
    margin-bottom: 0px;
  }

  ${TabTitle} {
    padding: 8px 16px;
  }
`;
